import { logger } from 'src/services';
import { create } from 'zustand';
import { isFromCareConnect } from 'src/utils';
import { validateTokenApi, ValidateTokenApiResponse } from 'src/api';

type State = {
  loading: boolean;
  error: { code: 500 | 403 | 404 } | null;
  chat: ValidateTokenApiResponse | null;
  token: string | null;
  validateChatToken: (access_token: string) => Promise<void>;
};

const useChatValidationStore = create<State>((set) => ({
  loading: false,
  error: null,
  chat: null,
  token: null,
  validateChatToken: async (token) => {
    set({ loading: true, token, error: null });
    try {
      const response = await validateTokenApi({ token });
      const chat = response.data;
      let error: State['error'] = null;

      const isChatLinkValid =
        chat?.valid &&
        ((!chat?.patientLogoutStatus && !chat?.expired) ||
          ((chat?.patientLogoutStatus || chat?.expired) &&
            isFromCareConnect()));

      if (!isChatLinkValid) {
        if (chat?.patientLogoutStatus) {
          error = { code: 403 };
        } else {
          error = { code: 500 };
        }
      }

      set({ chat, error, loading: false });
    } catch (error) {
      set({ error: { code: 500 }, loading: false });
      logger.error('Error validating chat link', { token }, error as Error);
    }
  },
}));

export { useChatValidationStore };
